const STORAGE_PREFIX = "gl-dev-proxy-history:";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

function storageKey(scope) {
  return `${STORAGE_PREFIX}${scope}`;
}

function readEntries(scope) {
  try {
    const parsed = JSON.parse(localStorage.getItem(storageKey(scope)));

    return Array.isArray(parsed)
      ? parsed.filter(
          (entry) => typeof entry?.url === "string" && typeof entry?.lastUsed === "number",
        )
      : [];
  } catch {
    return [];
  }
}

function writeEntries(scope, entries) {
  try {
    localStorage.setItem(storageKey(scope), JSON.stringify(entries));
  } catch {
    // Private browsing or a full quota just means history isn't persisted.
  }
}

function pruneExpired(entries, now) {
  return entries.filter((entry) => now - entry.lastUsed < MAX_AGE_MS);
}

/**
 * Most-recently-used first. Reading is also when expired entries get swept, so a
 * field nobody reopens for 30 days still empties out without a background job.
 */
export function getUrlHistory(scope, now = Date.now()) {
  const fresh = pruneExpired(readEntries(scope), now);

  writeEntries(scope, fresh);

  return fresh.sort((a, b) => b.lastUsed - a.lastUsed).map((entry) => entry.url);
}

export function recordUrlUsage(scope, url, now = Date.now()) {
  const trimmed = url?.trim();

  if (!trimmed) return;

  const entries = pruneExpired(readEntries(scope), now).filter(
    (entry) => entry.url !== trimmed,
  );

  entries.push({ url: trimmed, lastUsed: now });
  writeEntries(scope, entries);
}

export function removeUrlFromHistory(scope, url) {
  writeEntries(
    scope,
    readEntries(scope).filter((entry) => entry.url !== url),
  );
}

/** Sweeps every known scope, so fields that are no longer opened still get pruned. */
export function pruneAllHistories(scopes) {
  scopes.forEach((scope) => getUrlHistory(scope));
}
